import { EventEmitter, Injectable } from '@angular/core';
import { AlertService } from './alert.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  notFound = new EventEmitter<boolean>();

  constructor(private ALERT: AlertService) {}

  /**
   * check error status.
   * @param error object error
   * @author Martin Batun Tec.
   */
  check(error: HttpErrorResponse): void {
    console.error(error);
    switch (error.status) {
      case 400:
        {
          if (Array.isArray(error?.error?.errors)) {
            for (const e of error.error.errors) {
              if (e.message) {
                this.ALERT.error(e.message);
              }
            }
          }

          const message = error.error?.message || error.message;
          if (message) {
            this.ALERT.error(message);
          }
        }
        // this.ALERT.error(error.error?.message || error.message);
        break;
      case 401:
        // this.swal(error.error.error, true);
        break;
      case 403:
        // this.ALERT.error(error.error.message);
        break;
      case 404:
        this.notFound.next(true);
        // this.swal(error.error.mensaje);
        break;
      case 500:
        this.ALERT.error(`${error.error?.message}`);
        break;
      default:
        // this.swal('Error de conexion');
        break;
    }
  }
}
